//native
import React from 'react';
import Cookies from 'universal-cookie';
// import TagManager from 'react-gtm-module';

//components
import Main from '../childrens/main/.mixins/Main';
import Alerta from "../../../../../util/snackbars/.mixins/";

//controllers
import Config from '../../../../../../controllers/config';
import Pedidos_controller from '../../../../../../controllers/pedido';

export default class Politicas extends React.Component {

    constructor(props) {
        super(props);

        this.child = React.createRef();

        this.state = {
            nomeArquivo: null,
            tipo: null,
            data: null,
            file: null,
            isLoading: true,
            isError: false,
        };

        this.handlerArquivo = this.handlerArquivo.bind(this);
    };

    componentDidMount() {
        this.load();

        // TagManager.dataLayer({
        //     dataLayer: {
        //       event: 'event',
        //       eventCategory: 'tokstok:fornecedores:pedido-compra',
        //       eventAction: 'componentDidMount',
        //       eventLabel: 'componente-pedido-compra',
        //     }
        // });
    }

    toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });

    handlerArquivo = async (e) => {
        if (e.target.files.length > 0) {
            var filename = e.target.files[0].name;
            var tipo = e.target.files[0].type;
            var base64 = await this.toBase64(e.target.files[0]);
            var dataType = base64.split(';base64,')[1];
            this.setState({
                nomeArquivo:filename, 
                tipo: tipo,
                data: dataType
            });
            this.valTamanhoArquivo();
            this.valExtensaoArquivo();
            this.enviar();
        }
    }

    valTamanhoArquivo = () => {
        var file = document.querySelector('input[type="file"]').files[0];
        var tamanho = this.formatBytes(file.size);
        if (tamanho.size > 1.00) {
            document.querySelector('#tamanho').style.color = "red";
        } else {
            document.querySelector('#tamanho').style.color = "rgba(0, 0, 0, 0.54)";
        }
    };

    valExtensaoArquivo = () => {
        var file = document.querySelector('input[type="file"]').files[0];
        var length = file.name.split(".").length;
        var extension = file.name.split(".")[length-1];
        if (extension.toLowerCase() === 'pdf') {
            document.querySelector('#extensao').style.color = "rgba(0, 0, 0, 0.54)";
        } else {
            document.querySelector('#extensao').style.color = "red";
        }
    };

    formatBytes = (bytes) => {
        var kb = 1024;
        var ndx = Math.floor( Math.log(bytes) / Math.log(kb) );
        var fileSizeTypes = ["bytes", "kb", "mb", "gb", "tb", "pb", "eb", "zb", "yb"];
        
        return {
            size: +(bytes / kb / kb).toFixed(2),
            type: fileSizeTypes[ndx]
        };
    }

    load = async () => {
        const cookies = new Cookies();
        const token = cookies.get('User-Token');

        //carrega nome do arquivo
        const nomeFile = "sample.pdf";
        const tipoFile = "application/pdf";

        try {
            var result = await Pedidos_controller.getPedidoCompra(token,this.props.params);
            if (result.res.statusCode == 200) {
                this.setState({
                    nomeArquivo: nomeFile,
                    tipo: tipoFile,
                    data: result.body,
                    isLoading: false,
                });

                // TagManager.dataLayer({
                //     dataLayer: {
                //       event: 'event',
                //       eventCategory: 'tokstok:fornecedores:pedido-compra',
                //       eventAction: 'callback',
                //       eventLabel: `sucesso:lista-pedido-compra`,
                //     }
                // });
            } else {
                throw new Error("Ocorreu um erro ao fazer retorno do arquivo!");
            }
        } catch (error) {
            this.child.current.retorno('Ocorreu um erro ao fazer retorno do arquivo!','error');
            var errorString = "Ocorreu um erro ao fazer retorno do arquivo!";
            if (Config.DEBUG === "TRUE")
                errorString = error.message;
            this.setState({
                isError: true,
                isLoading: false,
                error: errorString
            });

            // TagManager.dataLayer({
            //     dataLayer: {
            //       event: 'event',
            //       eventCategory: 'tokstok:fornecedores:pedido-compra',
            //       eventAction: 'callback',
            //       eventLabel: `erro:${errorString}`,
            //     }
            // });
        }
        
    };

    receivedText = () => {
        showResult(fr, "Text");

        fr = new FileReader();
        fr.onload = receivedBinary;
        fr.readAsBinaryString(file);
    }

    render = () => {
        return (
            <div>
                <Main {...this}/>
                <Alerta ref={this.child}/>
            </div>
        );
    };

};